<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<span>时间：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					:clearable="false"
					type="datetimerange"
					align="right"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-NO-box">
				<span>订单编号：</span>
				<el-input v-model="ordernumber" placeholder="请输入订单编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-NO-box">
				<span>客户名称：</span>
				<el-input v-model="cusname" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>支付方式：</span>
				<el-select v-model="paymode" multiple collapse-tags placeholder="请选择支付方式" class="order-type-select" size="small">
					<!-- <el-option label="全部" value="全部"></el-option> -->
					<el-option label="线下支付" :value="0"></el-option>
					<el-option label="微信支付" :value="2"></el-option>
					<el-option label="预付货款支付" :value="4"></el-option>
					<el-option label="微企付支付" :value="6"></el-option>
					<el-option label="云资金-网商余额支付" :value="7"></el-option>
					<el-option label="云资金-汇付支付" :value="8"></el-option>
					<el-option label="云资金-中信支付" :value="9"></el-option>
					<el-option label="云资金-富友账户通支付" :value="10"></el-option>
					<el-option label="B2b门店助手-微信支付" :value="11"></el-option>
					<el-option label="B2b门店助手-银行转账" :value="12"></el-option>
					<el-option label="云资金-网商收银台" :value="13"></el-option>
					<el-option label="拉卡拉全渠道-余额支付" :value="14"></el-option>
					<el-option label="拉卡拉钱包余额" :value="16"></el-option>
					<!-- // TODO 过滤拉卡拉全渠道-收银台 -->
<!--					<el-option label="拉卡拉全渠道-收银台" :value="15"></el-option>-->
				</el-select>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			dateValue: [],
			paymode: [],
			cusname: '',
			ordernumber: '',
			collapse: true
		}
	},
	created () {
		this.initFilters()
	},
	methods: {
		clearSearch () {
			this.ordernumber = ''
			this.cusname = ''
			this.paymode = []
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		getFiltersDate () {
			// return [
			// 	{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]} 00:00:00`, 'op': 'ge', type: 'filtersParams' },
			// 	{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]} 23:59:59`, 'op': 'le', type: 'filtersParams' }
			// ]
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.dateValue && this.dateValue.length > 0) {
				filtersParams = [
					{ field: 'begindate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '时间' },
					{ field: 'enddate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '时间' }
				]
				// const monthDiff = this.getMonthDiff(this.dateValue[0], this.dateValue[1])
				// if (monthDiff > 0) {
				// 	this.$message.error('时间范围不得超过1个月！')
				// 	return false
				// }
			}
			if (this.cusname) {
				let cusnameObj = { 'field': 'cusname', 'data': this.cusname, 'op': 'cn' }
				filtersParams.push(cusnameObj)
			}
			if (this.ordernumber) {
				let ordernumberObj = { 'field': 'ordernumber', 'data': this.ordernumber, 'op': 'cn' }
				filtersParams.push(ordernumberObj)
			}
			if (this.paymode.length !== 0) {
				let paymodeObj = { 'field': 'paymode', 'data': this.paymode.join(','), 'op': 'in' }
				filtersParams.push(paymodeObj)
			}
			return {
				filtersParams,
				cParams
			}
		},
		getMonthDiff (startDate, endDate) {
			const start = new Date(startDate)
			const end = new Date(endDate)
			// const diffInMs = end - start
			const diffInMonth = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth())
			return diffInMonth
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 100px;
				text-align: right
			}
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
			.order-type-select {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
